export default "__VITE_ASSET__d2120ecc__"